module.exports = __webpack_public_path__ + "img/hero-photo-empty.bf7bc237.png";